export const COMPANY_TOOLBAR_TITLE = 'Companies';
export const CREATE_COMPANY_TITLE = 'Add a Company';
export const BACK_TO_MENU_TITLE = 'Back to Menu';

export const DEFAULT_ROWS_PER_PAGE = 50;

export const MANAGE_COMPANY_TABLE_HEAD_CELLS = [
  { id: 'name', center: true, disablePadding: false, label: 'Name' },
  { id: 'planName', center: true, disablePadding: false, label: 'Plan' },
  { id: 'status', center: true, disablePadding: false, label: 'Status' },
];

// Color map for plan badges shown in the companies table.
// Mirrors the role-badge UI used in ManageUsers (mu-role-badge).
// Current tier names first; the pre-rename names are kept below so a
// company that has not been migrated yet still gets a colour instead of
// falling through to the default.
export const PLAN_BADGE_COLORS = {
  Basic: '#6B7280',
  Regular: '#5B6ABF',
  Premium: '#2563EB',
  Alpha: '#D4A017',
  // legacy names (pre-rename ladder)
  Standard: '#6B7280',
  'Basic Package': '#6B7280',
  'Pro Elite': '#2563EB',
};

export const DEFAULT_SORT_BY_HEAD_CELL = 'name';

export const ENABLE_COMPANY_CHECKBOX_LABEL = 'Enable Company';

export const MONTHS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
];

export const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const PLAN_ROLES_MAP = {
  'Basic Package': [
    'ROLE_DASHBOARD',
    'ROLE_TRANSACTION',
    'ROLE_CUSTOMER',
    'ROLE_CUSTOMER_PRIVILEGIE',
    'ROLE_CUSTOMER_MOBILE',
    'ROLE_TICKET_OUT',
    'ROLE_BONUS',
    'ROLE_RAFFLE',
    'ROLE_CHECK_IN_OUT',
    'ROLE_POINT_WATCHING',
    'ROLE_EMPLOYEE_SESSION',
    'ROLE_NOTE',
    'ROLE_SETTINGS',
    'ROLE_RULES',
    'ROLE_MANAGE_USERS',
    'ROLE_ASSIGN_MACHINE',
    'ROLE_MACHINE',
    'ROLE_GAME',
    'ROLE_MANAGE_BONUS',
  ],
  Premium: [
    'ROLE_DASHBOARD',
    'ROLE_CUSTOMER',
    'ROLE_CUSTOMER_PRIVILEGIE',
    'ROLE_CUSTOMER_MOBILE',
    'ROLE_TRANSACTION',
    'ROLE_TICKET_OUT',
    'ROLE_BONUS',
    'ROLE_RAFFLE',
    'ROLE_CHECK_IN_OUT',
    'ROLE_POINT_WATCHING',
    'ROLE_EMPLOYEE_SESSION',
    'ROLE_NOTE',
    'ROLE_SETTINGS',
    'ROLE_RULES',
    'ROLE_MANAGE_USERS',
    'ROLE_ASSIGN_MACHINE',
    'ROLE_MACHINE',
    'ROLE_GAME',
    'ROLE_MANAGE_BONUS',
    'ROLE_READING',
    'ROLE_MASTER_READING',
    'ROLE_MACHINE_PICTURE',
    'ROLE_ADD_MACHINE_READING',
    'ROLE_ACCOUNTING',
    'ROLE_REPORT',
    'ROLE_CUSTOMER_LOAN_REPORT',
    'ROLE_EMPLOYEE_SHORT_REPORT',
    // ROLE_ATM_TRANSACTION removed — ATM Transaction is Alpha-tier
    // only and is granted exclusively via the V3 wizard's Alpha plan.
  ],
};

export const WIZARD_STEPS = [
  { key: 'company', label: 'Company' },
  { key: 'plan', label: 'Plan' },
  { key: 'addons', label: 'Add-Ons' },
  { key: 'license', label: 'License' },
  { key: 'review', label: 'Review' },
];

export const PLAN_DETAILS = {
  'Basic Package': {
    name: 'Basic',
    price: 99,
    recommended: false,
    features: [
      'Dashboard & Reporting',
      'Customer Management',
      'Transaction Tracking',
      'Employee Clock In/Out',
      'Bonus & Raffle System',
      'Machine & Game Setup',
      'Notes & Rules',
    ],
  },
  Premium: {
    name: 'Premium',
    price: 199,
    recommended: true,
    features: [
      'Everything in Basic',
      'Master Reading Sessions',
      'Machine Picture Tracking',
      'Advanced Machine Readings',
      'Full Accounting Suite',
      'Customer & Employee Loan Reports',
    ],
  },
};

export const ADD_ONS = [
  {
    id: 'security_gate',
    name: 'Security Gate Access',
    description:
      'NFC gate check-in, blacklist alerts, and real-time security monitoring',
    price: 35,
    category: 'Security',
  },
  {
    id: 'wallet_passes',
    name: 'Digital Wallet Passes',
    description: 'Apple Wallet & Google Wallet pass generation for customers',
    price: 25,
    category: 'Security',
  },
  {
    id: 'advanced_reports',
    name: 'Advanced PDF Reports',
    description:
      'Shift reports, raffle reports, bonus reports, and master reading exports',
    price: 30,
    category: 'Reporting',
  },
  {
    id: 'weekly_analytics',
    name: 'Weekly Analytics',
    description:
      'Automated weekly financial reports with manager bank summaries',
    price: 25,
    category: 'Reporting',
  },
  {
    id: 'customer_history',
    name: 'Extended Customer History',
    description: 'Full historical customer archive with point history tracking',
    price: 20,
    category: 'Storage / History',
  },
  {
    id: 'multi_location',
    name: 'Multi-Location Support',
    description: 'Link and manage multiple locations under one company account',
    price: 40,
    category: 'Compliance',
  },
];

export const ADD_ON_CATEGORIES = [
  'Security',
  'Reporting',
  'Storage / History',
  'Compliance',
];

export const DURATION_OPTIONS = [
  { label: '1 Month', value: '1M' },
  { label: '3 Months', value: '3M' },
  { label: '6 Months', value: '6M' },
  { label: '1 Year', value: '1Y' },
];
